export const GET_SOURCE_VALUES = 'GET_SOURCE_VALUES';
export const GET_SOURCE_VALUE_BY_ID = 'GET_SOURCE_VALUE_BY_ID';
export const UPDATE_SOURCE_VALUE = 'UPDATE_SOURCE_VALUE';
export const DELETE_SOURCE_VALUE = 'DELETE_SOURCE_VALUE';
export const CREATE_SOURCE_VALUE = 'CREATE_SOURCE_VALUE';
